/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `Kód slevy byl úspěšně použit`
};

const da_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `Rabatkoden er anvendt`
};

const de_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `Der Rabattcode wurde erfolgreich angewendet`
};

const en_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `The discount code has been successfully applied`
};

const es_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `El código promocional se ha aplicado correctamente`
};

const fr_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `Le code promo a été appliqué avec succès`
};

const hu_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `A promóciós kód sikeresen alkalmazva`
};

const it_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `Codice sconto applicato con successo`
};

const nl_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `De kortingscode is succesvol toegepast`
};

const pl_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `Kod rabatowy został pomyślnie zastosowany`
};

const pt_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `O código promocional foi aplicado com sucesso`
};

const sv_discount_code_messages_applied = /** @type {(inputs: {}) => string} */ () => {
	return `Rabattkoden har tillämpats`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_code_messages_applied = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_code_messages_applied(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_code_messages_applied", locale)
	if (locale === "cs") return cs_discount_code_messages_applied(inputs)
	if (locale === "da") return da_discount_code_messages_applied(inputs)
	if (locale === "de") return de_discount_code_messages_applied(inputs)
	if (locale === "en") return en_discount_code_messages_applied(inputs)
	if (locale === "es") return es_discount_code_messages_applied(inputs)
	if (locale === "fr") return fr_discount_code_messages_applied(inputs)
	if (locale === "hu") return hu_discount_code_messages_applied(inputs)
	if (locale === "it") return it_discount_code_messages_applied(inputs)
	if (locale === "nl") return nl_discount_code_messages_applied(inputs)
	if (locale === "pl") return pl_discount_code_messages_applied(inputs)
	if (locale === "pt") return pt_discount_code_messages_applied(inputs)
	return sv_discount_code_messages_applied(inputs)
};
export { discount_code_messages_applied as "discount_code_messages.applied" }